import firebase from "firebase/compat/app"
import "firebase/compat/firestore"
import "firebase/compat/auth"
import "firebase/compat/database"
import "firebase/compat/storage"


const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
}

const app = firebase.initializeApp(firebaseConfig)

function getAuthMe() {
    let authInstance = null
    try {
        authInstance = firebase.auth(app)
    } catch (e) {
        console.log("Unable to start auth")
    }
    return authInstance
}

export const dbRT = firebase.database()
export const authFirebase = getAuthMe()
export const db = firebase.firestore()
export const dbST = firebase.storage()